<template>
	<div class="pages-error404"></div>
</template>
<script>
import Vue from "vue";

export default {
	name: "Error404",
	props: {
		name: String,
	},
	data() {
		return {};
	},
	computed: {},
	methods: {},
	mounted() {},
	components: {},
};
</script>
